<app-top-nav></app-top-nav>
<div class="container">
  <div class="main-content">
    <div class="header-section">
      <h1>Employees</h1>
      <div class="view-toggle">
        <button
          class="view-toggle-btn"
          [class.active]="currentView === 'table'"
          (click)="setView('table')"
        >
          📊 Table View
        </button>
        <button
          class="view-toggle-btn"
          [class.active]="currentView === 'orgchart'"
          (click)="setView('orgchart')"
        >
          🏢 Org Chart
        </button>
      </div>
    </div>

    <!-- Table View -->
    <div class="table-view" *ngIf="currentView === 'table'">
      <table class="employees-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Job</th>
            <th>Time</th>
            <th>Key Strengths</th>
            <th>Project</th>
            <th>More</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let employee of employees"
            (click)="viewDetails(employee.id)"
          >
            <td>{{ employee.name }}</td>
            <td>{{ employee.job }}</td>
            <td>{{ employee.time }}</td>
            <td>
              <span class="chip" *ngFor="let strength of employee.strengths">
                {{ strength }}
              </span>
            </td>
            <td>{{ employee.project }}</td>
            <td>
              <button class="more-btn">⋮</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Org Chart View -->
    <div class="org-chart-view" *ngIf="currentView === 'orgchart'">
      <div class="org-chart-placeholder">
        <h3>My Team</h3>
        <app-organization-chart></app-organization-chart>
      </div>
    </div>
  </div>
</div>
